import { useState } from "react"
import { useNavigate, useLocation } from "react-router-dom"
import { FileText, Clipboard, IndianRupee, Scan, Search, Download, Share2, BarChart3 } from "lucide-react"
import { Input } from "../components/ui/input.tsx"
import { Button } from "../components/ui/button.tsx"
import { ProfileLayout } from "../components/ProfileLayout"

export default function MyReportsPage() {
  const navigate = useNavigate()
  const [searchQuery, setSearchQuery] = useState("")

  const handleLogout = () => {
    localStorage.removeItem("user")
    navigate("/")
  }

  return (
    <ProfileLayout onLogout={handleLogout}>
      <div className="bg-gray-50 min-h-screen">
        <div className="bg-white shadow-sm border-b border-gray-200 p-6 mb-6">
          <div className="flex items-center gap-3">
            <FileText className="w-6 h-6 text-red-600" />
            <h1 className="text-2xl font-bold text-gray-900">Health Reports</h1>
          </div>
        </div>

        <div className="px-4 md:px-8">
          <div className="max-w-7xl mx-auto">
            {/* <div className="flex justify-end mb-6">
              <Button variant="outline" className="gap-2 w-full sm:w-auto">
                <BarChart3 className="w-4 h-4" />
                Compare Reports
              </Button>
            </div> */}

            <div className="bg-white rounded-lg shadow-sm border border-gray-200">
            <div className="p-4 border-b">
              <div className="relative">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
                <Input
                  placeholder="Search documents..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="pl-10"
                />
              </div>
            </div>

            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-gray-50 border-b">
                  <tr>
                    <th className="px-4 md:px-6 py-3 text-left text-xs md:text-sm font-medium text-gray-700">Phone Number</th>
                    <th className="px-4 md:px-6 py-3 text-left text-xs md:text-sm font-medium text-gray-700">Date</th>
                    <th className="px-4 md:px-6 py-3 text-left text-xs md:text-sm font-medium text-gray-700">Download</th>
                    <th className="px-4 md:px-6 py-3 text-left text-xs md:text-sm font-medium text-gray-700 hidden sm:table-cell">AI Analysis</th>
                    <th className="px-4 md:px-6 py-3 text-left text-xs md:text-sm font-medium text-gray-700 hidden sm:table-cell">Share</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td colSpan="5" className="px-4 md:px-6 py-12 text-center text-gray-500 text-sm">
                      No reports available
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            </div>
          </div>
        </div>
      </div>
    </ProfileLayout>
  )
}
